export const ROUTE_INFO = {
  adminCreateReport: {
    label: 'Create Report',
    path: '/admin/reports/create',
  },
  adminEditReport: {
    label: 'Edit Report',
    path: '/admin/report/:reportId/edit',
  },
  runReport: {
    label: 'Run Report',
    path: '/app/run-report',
  },
  userDashboard: {
    label: 'User Dashboard',
    path: '/app/dashboard',
  },
  adminDashboard: {
    label: 'Admin Dashboard',
    path: '/admin/dashboard',
  },
  homePage: {
    label: 'Home Page',
    path: '/',
  },
  userConfigureReport: {
    label: 'Configure Report',
    path: '/app/configure-report/:id',
  },
  userEditReport: {
    label: 'Edit Report',
    path: '/app/report/:reportId/edit',
  },
  runSavedReport: {
    label: 'Run Saved Report',
    path: '/app/saved-report/:id/correlationId/:correlationId/:exportFileCorrelationId/preview',
  },
  viewReportSnapshot: {
    label: 'View Report Snapshot',
    path: '/app/report-snapshot/:snapshotId/preview',
  },
};
